module.exports = __webpack_public_path__ + "static/img/img_qrcode.fbe9e34.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_pc/img_qrcode.gif
// module id = 6GS7
// module chunks = 0